<template>
<main class="pattern p-0">
    <div class="p-0">
        <b-container id="advertisement" class="p-0">
            <carousel :autoHeight="false" animateOut="fadeOut" :items="1" :loop="true" :center="false" :margin="20" :autoplayTimeout="2000" :nav="false" :dots="false" autoplay="true" :navigation="true" class="owl-theme" id="carousel">
                <div class="item p-0" v-for="(image, index) in images" :key="index">
                    <img :height="carouselHeight" :style="'width:' + imageWidth" :src="image" />
                </div>
            </carousel>
        </b-container>
    </div>
</main>
</template>

<script>
import carousel from "vue-owl-carousel2";
export default {
    props: {
        images: {
            type: Array,
            default: [
                "https://placeimg.com/150/180/any?1",
                "https://placeimg.com/150/180/any?2",
                "https://placeimg.com/150/180/any?3",
                "https://placeimg.com/150/180/any?4",
                "https://placeimg.com/150/180/any?5",
                "https://placeimg.com/150/180/any?6",
                "https://placeimg.com/150/180/any?7",
            ],
        },
    },

    components: {
        carousel,
    },
    data: () => ({
        carouselHeight: "500",
        imageWidth: "280",
        // images: [
        //   "https://placeimg.com/280/390/any?1",
        //   "https://placeimg.com/280/390/any?2",
        //   "https://placeimg.com/280/390/any?3",
        //   "https://placeimg.com/280/390/any?4",
        //   "https://placeimg.com/280/390/any?5",
        //   "https://placeimg.com/280/390/any?6",
        //   "https://placeimg.com/280/390/any?7"
        // ]
    }),
};
</script>

<style>
.owl-carousel.owl-drag .owl-item {
    height: 300px ;
}

.owl-carousel .owl-item img {
    height: 300px ;
}

.strip figure img {
    top: 40% !important;
}

#advertisement{
      max-width: 365px !important;
      
  }
</style>
